import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "pathways_legend_icon",
  "use": "pathways_legend_icon-usage",
  "viewBox": "0 0 11.295 9.644",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 11.295 9.644\" id=\"pathways_legend_icon\"><g data-name=\"legend - shape\" fill=\"none\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M5.648 8.144H9.8V1.5L5.652 2.957 1.5 1.5v6.644z\" /><path d=\"M9.795 8.144V1.5L5.648 2.957 1.5 1.5v6.644h8.295m0 1.5H1.5a1.5 1.5 0 0 1-1.5-1.5V1.5A1.5 1.5 0 0 1 1.997.085l3.65 1.282L9.298.085A1.5 1.5 0 0 1 11.295 1.5v6.644a1.5 1.5 0 0 1-1.5 1.5z\" fill=\"#46a8f6\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol